export default __webpack_public_path__ + "static/media/pdf.5523de6d.png";